export default __webpack_public_path__ + "static/media/flag-virgin-islands.b5d86fd0.svg";